import Search from "../../search/Search";
import SearchApi from "../../../api/SearchApi";

const Place = props => {
    return (
        <Search api={SearchApi.searchPlace} targetPlaceholder={'플레이스 코드'} dataIdx={[5, 4]} />
    )
}

export default Place;